import { MdKeyboardArrowDown, MdKeyboardArrowRight } from 'react-icons/md';
import { ClusterColumn } from '../../types';
import { formatClusterLabel } from '../../utils';
import styles from './ClusterHeaderCell.module.scss';

type ClusterHeaderCellProps = {
  column: ClusterColumn;
  isExpanded: boolean;
  onToggle: () => void;
};

export const ClusterHeaderCell = ({ column, isExpanded, onToggle }: ClusterHeaderCellProps) => {
  const label = formatClusterLabel(column.clusterName, column.clusterStoresCount);
  const ArrowIcon = isExpanded ? MdKeyboardArrowDown : MdKeyboardArrowRight;

  return (
    <button type="button" className={styles.button} aria-expanded={isExpanded} title={label} onClick={onToggle}>
      <ArrowIcon className={styles.icon} aria-hidden />
      <span className={styles.label}>{label}</span>
    </button>
  );
};
